module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-sheet', {
    staticClass: "d-flex align-center",
    class: _vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand) < _vm.screenwidth ? 'justify-center' : 'justify-start',
    attrs: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadSVG
    }
  }, [_c('v-icon', [_vm._v("download")])], 1), _vm._v(" "), _c('v-sheet', {
    staticClass: "mx-0 overflow-hidden",
    attrs: {
      "width": "100%",
      "height": "calc(100vh - 170px)"
    }
  }, [_c('SvgPanZoom', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 170px)"
    },
    attrs: {
      "zoomEnabled": true,
      "controlIconsEnabled": true,
      "fit": false,
      "center": true,
      "maxZoom": "2"
    },
    on: {
      "created": function($event) {
        return _vm.registerSvgPanZoom()
      }
    }
  }, [_c('svg', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "id": "svgStammbaum",
      "width": Math.max(_vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand) + 50, _vm.windowWidth),
      "height": Math.max((_vm.endJahr - _vm.startJahr + 1) * 64, _vm.windowHeight)
    }
  }, [_c('stammbaumKnoten', {
    attrs: {
      "sohn": _vm.leibfamilie.sohn,
      "bbr": _vm.leibfamilie.bbr,
      "getArrayDepth": _vm.leibfamilie.getArrayDepth,
      "blatter": _vm.leibfamilie.blatter,
      "ebene": 0,
      "currentBbr": _vm.currentBbr,
      "dense": _vm.dense,
      "kachelbreite": _vm.kachelbreite,
      "startJahr": _vm.startJahr,
      "xStart": (_vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand)) / 2 - 50,
      "xMin": 0,
      "xWidth": _vm.leibfamilie.blatter * (_vm.kachelbreite + _vm.abstand),
      "xVater": 0,
      "yVater": 0,
      "collapse": _vm.collapse
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcdf28ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/stammbaum.vue
// module id = 823
// module chunks = 15